<h1  mat-dialog-title>Thank you. You will be kept updated as development progresses</h1>
    <mat-dialog-content>  

    </mat-dialog-content>
<mat-dialog-actions>
    <button  mat-raised-button (click)="closeMe()">Close</button>
</mat-dialog-actions>